import React from 'react';
import Classes from 'classnames';

const debug = {
    dev: false,
    head: '[Checkbox]'
};


type Props = {
    form?     : any
    name?     : string
    size?     : "13" | "16"
    onChange? : callback
    disabled? : boolean
    className?: string
    value?    : boolean
}

export default class FormCheckbox extends React.Component<Props> {

    static defaultProps = {
        size: '13'
    }

    public value : boolean

    constructor(props: Props) {
        super(props);

        if (this.props.form) {
            this.props.form.registerFormComponent(this.props.name,this);
        }

        this.value = false
    }

    // onChange = (event) => {
    //
    //     if (debug.dev) console.log(debug.head,".onChange()",event.target.checked);
    //     const newValue = event.target.checked;
    //
    //     if (this.props.form) this.props.form.onFormComponentValueChange(this.props.name,newValue);
    //     if (this.props.onChange) this.props.onChange(newValue);
    //
    //     // we need to re-render the field becuase it's BASIC controll
    //     this.forceUpdate();
    // };

    onClick = (e: React.SyntheticEvent) => {

        const newValue = !this.value;

        e.preventDefault();
        e.stopPropagation();

        if (this.props.form) this.props.form.onFormComponentValueChange(this.props.name,newValue);
        if (this.props.onChange) this.props.onChange(newValue);

        // we need to re-render the field becuase it's BASIC controll
        this.forceUpdate();
    };

    render() {

        if (debug.dev) console.log(debug.head,".render val = ", this.value);

        this.value = false;
        if (this.props.form) {
            this.value = this.props.form.getValue(this.props.name);
        } else if (this.props.value) {
            this.value = this.props.value;
        }

        const classes = Classes('ui5-cb', 's-{0}'.f(this.props.size), this.props.className, {
            'selected': this.value,
            'disabled': this.props.disabled
        });

        return <div className={classes} onClick={this.onClick}/>;
    }


}

